import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import IVR from "../app/components/Nodes";
import Logout from "../app/layout/Logout";
import PropType from "prop-types";
import Console from "../app/layout/Console";
import { Navigate } from "react-router";
import Workspaces from "../app/layout/Workspaces";
import IVRFlows from "../app/layout/IVRFlows";

const AppRouter = (props) => {
  console.log("AppRouter component is rendered.");
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/console" />} />
        <Route path="/console" element={<Workspaces />} />
        <Route path="/console/:tenantName" element={<IVRFlows />}>
        </Route>
        <Route path="/logout" element={<Logout />} />
        <Route
          path="/console/:workspace"
          element={<Console signOut={props.signOut} />}
        >
          <Route path="flow/:flowId" element={<IVR />} />
        </Route>
        <Route path="*" element={<Navigate to="/console" />}></Route>
      </Routes>
    </Router>
  );
};

// used to validate the type of props passed to the component
AppRouter.propTypes = {
  signOut: PropType.func.isRequired,
};

export default AppRouter;
